export default {
  listaUsers: [],
  user: {
    firstName: '',
    lastName: '',
    nomeCompleto: '',
    email: '',
    password: '',
    perfil: [
      {
        id: '',
      },
    ],
  },
  systemPermission: [],
  userPermissions: [],
}
